import React from 'react';
import { createRoot } from 'react-dom/client';
import { CardWall } from '../components/CardWall';

console.log('Client-side script loaded!');

const cardWallRoot = document.getElementById('card-wall-root');
if (cardWallRoot) {
    console.log('Found card-wall-root, mounting...');
    const root = createRoot(cardWallRoot);
    root.render(React.createElement(CardWall));
} else {
    console.warn('card-wall-root not found');
}

const langSwitcher = document.getElementById('language-switcher') as HTMLSelectElement;
if (langSwitcher) {
    langSwitcher.addEventListener('change', (e) => {
        const target = e.target as HTMLSelectElement;
        window.location.href = target.value;
    });
}
